<template>
	<LoadingOverlay v-if="loading">
		<template v-slot:heading>
			Authenticating, wait a second...
		</template>
	</LoadingOverlay>
</template>

<script>
import Api from '../../../api';
import {mapActions, mapGetters} from "vuex";
import LoadingOverlay from "../LoadingOverlay";

export default {
  name: "TwitterCallback.vue",
  components: {LoadingOverlay},
  data() {
    return {
      loading: false
    }
  },
  async created() {
    try {
      const { oauth_token, oauth_verifier } = this.$route.query;
      if (!oauth_token || !oauth_verifier) {
        await this.$router.push('/auth');
      } else {
        await this.authenticateWithTwitter(oauth_token, oauth_verifier);
        this.closeWindow();
      }
    }  catch (e) {
      this.loading = false;
      this.closeWindow();
    }
  },
  computed: {
    ...mapGetters([
      'redirectAfterAuthUrl'
    ])
  },
  methods: {
    ...mapActions([
      'authenticate'
    ]),

    async authenticateWithTwitter(oauth_token, oauth_verifier) {
      this.loading = true;
      const credentials = await Api.getTwitterAccessToken({
        oauth_token,
        oauth_verifier,
        oauth_nonce: Date.now()
      });
      await this.loginWithTwitter(credentials);
      this.loading = false;
    },

    async loginWithTwitter(res) {
      const authData = await Api.loginWithTwitter({ oauth_token: res.oauth_token, access_token_secret: res.oauth_token_secret });
      await this.authenticate(authData);
    },

    closeWindow() {
      setTimeout(window.close, 301)
    }
  }
}
</script>

<style scoped>

</style>
